import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';

/**
 * Singleton Apollo Client instance for use in loaders
 * This allows loaders to access the Apollo Client outside of React context
 */
let apolloClient: ApolloClient<NormalizedCacheObject> | null = null;

/**
 * Get the Apollo Client instance
 * @throws Error if client hasn't been initialized
 */
export function getApolloClient(): ApolloClient<NormalizedCacheObject> {
  if (!apolloClient) {
    throw new Error('Apollo Client not initialized. Call setApolloClient() first.');
  }

  return apolloClient;
}

/**
 * Set the Apollo Client instance
 * Should be called once during app initialization
 */
export function setApolloClient(client: ApolloClient<NormalizedCacheObject>): void {
  apolloClient = client;
}
